/**
 * PATH: apps/quote/src/components/builder/panels/takeoff-assist/SuggestedAppCard.tsx
 * PURPOSE: AI-suggested application card
 */

import { Sparkles, Star, Check, Plus, Loader2 } from 'lucide-react'
import type { TakeoffSuggestedApplication } from '@/lib/quoteApi'

export default function SuggestedAppCard({
  app, onApply, onAddNew, isApplying,
}: {
  app: TakeoffSuggestedApplication; onApply: () => void; onAddNew: () => void; isApplying: boolean
}) {
  return (
    <div className="p-3 bg-gradient-to-r from-purple-50 to-blue-50 dark:from-purple-900/20 dark:to-blue-900/20 rounded-lg border border-purple-200 dark:border-purple-800/50">
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5">
            <Sparkles className="w-3.5 h-3.5 text-purple-500" />
            <span className="text-sm font-medium text-slate-900 dark:text-white">{app.name || app.code}</span>
            {app.is_popular && <Star className="w-3 h-3 text-amber-500 fill-amber-500" />}
          </div>
          <p className="text-xs text-slate-500 mt-0.5">{app.supplier_name} • {app.substrate_type}</p>
          {app.matched_keywords.length > 0 && (
            <div className="flex flex-wrap gap-1 mt-1.5">
              {app.matched_keywords.map((kw) => (
                <span key={kw} className="text-[10px] px-1.5 py-0.5 bg-purple-100 dark:bg-purple-900/50 text-purple-700 dark:text-purple-300 rounded">{kw}</span>
              ))}
            </div>
          )}
        </div>
        <div className="flex flex-col items-end gap-1">
          <span className="text-[10px] text-purple-600 dark:text-purple-400 font-medium">{app.score}% match</span>
          <div className="flex items-center gap-1">
            <button onClick={onApply} disabled={isApplying} className="p-1.5 bg-purple-600 text-white rounded hover:bg-purple-700 disabled:opacity-50" title="Apply to selected row">
              {isApplying ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Check className="w-3.5 h-3.5" />}
            </button>
            <button onClick={onAddNew} className="p-1.5 bg-slate-600 text-white rounded hover:bg-slate-700" title="Add as new row">
              <Plus className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
